// クレアショット 公式LINE登録LP（Apple風・2026-10-15）の動き。sections/creashot-line-apple.liquid から module で読む。
// ・[data-pin] の要素に、そのスクロール区間の進み具合を --p（0〜1）で渡す（見た目はCSS側で計算）
// ・ファーストビューは three.js で個包装スティックを立体にし、スクロールで回転→28本の輪→退場（assets/fp-3d-stick.js）
// ・動きを減らす設定 / WebGLなしのときは .csl に data-static を付け、静止レイアウトで全部読めるようにする
const root = document.querySelector('.csl');
if (root) init(root);

function init(root) {
  const cfg = JSON.parse(root.getAttribute('data-cfg') || '{}');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));

  // ---------- 区間ごとの --p ----------
  const pins = [...root.querySelectorAll('[data-pin]')];
  let vh = innerHeight;
  function measure() {
    vh = innerHeight;
    for (const el of pins) {
      const rail = el.querySelector('.csl-zero__rail');
      if (rail) el.style.setProperty('--dx', Math.max(0, rail.scrollWidth - innerWidth) + 'px');
    }
  }
  function update() {
    for (const el of pins) {
      const r = el.getBoundingClientRect();
      const mode = el.dataset.pin;
      let p;
      if (mode === 'view') p = clamp((vh - r.top) / (vh + r.height)); // 画面に入ってから出るまで
      else { const span = r.height - vh; p = span > 0 ? clamp(-r.top / span) : 0; } // 貼り付いている間
      el.style.setProperty('--p', p.toFixed(4));
    }
  }
  if (reduce) root.setAttribute('data-static', 'true');
  else {
    let tick = 0;
    const onScroll = () => { if (!tick) tick = requestAnimationFrame(() => { tick = 0; update(); }); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', () => { measure(); update(); });
    measure(); update();
  }

  // ---------- 画面に入ったら出す・数字を数える・動画を再生 ----------
  const io = new IntersectionObserver((es) => {
    for (const e of es) {
      const el = e.target;
      if (el.tagName === 'VIDEO') { e.isIntersecting ? el.play().catch(() => {}) : el.pause(); continue; }
      if (!e.isIntersecting) continue;
      el.classList.add('is-in');
      if (el.dataset.count) countUp(el);
      io.unobserve(el);
    }
  }, { rootMargin: '0px 0px -12% 0px' });
  root.querySelectorAll('.csl-r,[data-count],.csl-end').forEach((el) => io.observe(el));
  root.querySelectorAll('video[data-auto]').forEach((v) => { v.muted = true; io.observe(v); });

  function countUp(el) {
    const to = +el.dataset.count, dec = +(el.dataset.dec || 0);
    const fmt = (n) => n.toLocaleString('ja-JP', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    if (reduce) { el.textContent = fmt(to); return; }
    const t0 = performance.now(), dur = 1400;
    const step = (now) => {
      const k = clamp((now - t0) / dur), e = 1 - Math.pow(1 - k, 4);
      el.textContent = fmt(to * e);
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  // ---------- ナビの色・追従ボタン ----------
  const nav = root.querySelector('.csl-nav');
  const hero = root.querySelector('.csl-hero');
  const end = root.querySelector('.csl-end');
  const sticky = root.querySelector('.csl-sticky');
  function chrome() {
    const hb = hero ? hero.getBoundingClientRect().bottom : 0;
    const past = hb < 60;
    if (nav) nav.classList.toggle('is-light', past);
    if (sticky) {
      const er = end ? end.getBoundingClientRect() : null;
      const atEnd = er && er.top < vh * 0.9 && er.bottom > 0;
      sticky.classList.toggle('is-on', past && !atEnd);
    }
  }
  addEventListener('scroll', chrome, { passive: true });
  chrome();

  // ---------- 3Dファーストビュー ----------
  if (hero) {
    const glOk = (() => { try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch (e) { return false; } })();
    if (reduce || !glOk || !cfg.three) hero.setAttribute('data-static', 'true');
    else hero3d(hero, cfg).catch((e) => { console.warn('[csl3d]', e); hero.setAttribute('data-static', 'true'); });
  }
}

async function hero3d(root, cfg) {
  const THREE = await import(cfg.three);
  const { buildStick } = await import(cfg.stickJs);
  const track = root.querySelector('.csl-hero__track');
  const stage = root.querySelector('.csl-hero__stage');
  const canvas = root.querySelector('.csl-hero__canvas');
  const copies = [...root.querySelectorAll('.csl-hero__copy')];
  const bar = root.querySelector('.csl-hero__bar span');
  const hint = root.querySelector('.csl-hero__hint');

  const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  renderer.setPixelRatio(Math.min(devicePixelRatio || 1, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.NeutralToneMapping; // 版下の色をそのまま出す
  renderer.toneMappingExposure = 1.12;
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 100);

  const kit = await buildStick(THREE, renderer, { front: cfg.front, back: cfg.back });
  scene.environment = kit.env;
  scene.add(...kit.lights);
  const W = kit.W, H = kit.H, N = 28;
  const world = new THREE.Group();
  scene.add(world);
  const sticks = [];
  for (let i = 0; i < N; i++) { const s = kit.makeStick(); s.visible = i === 0; world.add(s); sticks.push(s); }
  const hero = sticks[0];

  // 床の影（ライム背景になじむ濃い緑）
  const shadow = (() => {
    const c = document.createElement('canvas'); c.width = c.height = 128;
    const x = c.getContext('2d'); const g = x.createRadialGradient(64, 64, 0, 64, 64, 64);
    g.addColorStop(0, 'rgba(20,55,0,.5)'); g.addColorStop(1, 'rgba(20,55,0,0)');
    x.fillStyle = g; x.fillRect(0, 0, 128, 128);
    const m = new THREE.Mesh(new THREE.PlaneGeometry(1, 1), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(c), transparent: true, depthWrite: false }));
    m.rotation.x = -Math.PI / 2;
    return m;
  })();
  scene.add(shadow);

  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const seg = (p, a, b) => clamp((p - a) / (b - a));
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const lerp = (a, b, t) => a + (b - a) * t;
  let vw = 1, vh = 1, mobile = false;
  function resize() {
    vw = stage.clientWidth; vh = stage.clientHeight;
    mobile = vw / vh < 0.85;
    renderer.setSize(vw, vh, false);
    camera.aspect = vw / vh; camera.updateProjectionMatrix();
  }
  const fit = (w, h) => { const t = Math.tan(THREE.MathUtils.degToRad(camera.fov / 2)); return Math.max(h / (2 * t), w / (2 * t * camera.aspect)); };

  let target = 0, prog = 0, mx = 0, my = 0, sx = 0, sy = 0, visible = true;
  function readScroll() { const r = track.getBoundingClientRect(); const span = r.height - vh; target = span > 0 ? clamp(-r.top / span) : 0; }
  addEventListener('scroll', readScroll, { passive: true });
  addEventListener('resize', () => { resize(); readScroll(); });
  addEventListener('pointermove', (e) => { mx = e.clientX / innerWidth - 0.5; my = e.clientY / innerHeight - 0.5; }, { passive: true });
  // スマホは傾きでも少し動かす（許可が要らない端末だけ）
  addEventListener('deviceorientation', (e) => { if (e.gamma == null) return; mx = clamp(e.gamma / 60, -0.5, 0.5); my = clamp((e.beta - 45) / 90, -0.5, 0.5); }, { passive: true });
  new IntersectionObserver((es) => { visible = es[0].isIntersecting; if (visible) loop(); }).observe(stage);

  const R = (W * 1.32 * N) / (2 * Math.PI);
  const ringPos = (i) => { const a = (i / N) * Math.PI * 2; return [Math.sin(a) * R, 0, Math.cos(a) * R, a]; };
  let raf = 0; const t0 = performance.now();

  function frame(now) {
    raf = 0;
    const t = (now - t0) / 1000;
    prog += (target - prog) * 0.09;
    sx += (mx - sx) * 0.05; sy += (my - sy) * 0.05;
    const p = prog;
    const pIn = ease(clamp(t / 1.4)); // 開いた直後に下から回りながら立ち上がる
    const pSpin = ease(seg(p, 0.18, 0.44));
    const pRing = ease(seg(p, 0.46, 0.68));
    const pOut = ease(seg(p, 0.74, 0.96));

    const dHero = mobile ? fit(W * 3.1, H * 2.35) : fit(W * 9, H * 1.35);
    const dRing = fit(R * 2 + W * 3, H * 2.6);
    const dist = lerp(dHero, dRing, pRing) * lerp(1, 1.12, pOut);
    camera.position.set(sx * 0.4, lerp(0, H * 0.75, pRing) - sy * 0.3, dist);
    // 28本の段階は見出しが上なので輪を下寄せ、最後はボタンが下なので輪を上へ逃がす
    camera.lookAt(0, lerp(0, H * 0.32, pRing) - H * (mobile ? 1.25 : 0.95) * pOut, 0);

    const side = mobile ? 0 : W * 2.6;
    const heroX = lerp(lerp(side, -side, pSpin), ringPos(0)[0], pRing);
    const heroZ = lerp(0, ringPos(0)[2], pRing);
    const idle = Math.sin(t * 0.9) * 0.06;
    const baseY = mobile ? -H * 0.42 : 0;
    hero.position.set(heroX, lerp(-H * 2.2, 0, pIn) + idle * (1 - pRing) + lerp(baseY, 0, pRing), heroZ);
    hero.rotation.set(
      lerp(-0.08, 0, pRing) + sy * 0.15,
      lerp(-0.42 + Math.sin(t * 0.6) * 0.1 + sx * 0.5 + (1 - pIn) * 2.4, Math.PI * 2 + 0.35, pSpin) * (1 - pRing) + ringPos(0)[3] * pRing,
      lerp(lerp(0.12, -0.38, pSpin), 0, pRing)
    );

    world.rotation.y = pRing > 0.001 ? (pRing * 0.6 + pOut * Math.PI * 0.9 + t * 0.05) * pRing : 0;
    for (let i = 1; i < N; i++) {
      const s = sticks[i];
      const k = ease(clamp(pRing * 1.6 - (i / N) * 0.6));
      s.visible = k > 0.001;
      if (!s.visible) continue;
      const [x, y, z, a] = ringPos(i);
      s.position.set(lerp(heroX, x, k), lerp(H * 0.6, y, k) + Math.sin(t * 1.3 + i) * 0.03 * k, lerp(heroZ, z, k));
      s.rotation.set(0, a, lerp(0.6, 0, k));
      s.scale.setScalar(lerp(0.4, 1, k));
    }
    shadow.position.x = heroX * (1 - pRing);
    shadow.position.y = lerp(hero.position.y, 0, pRing) - H * 0.5 - lerp(0.42, 0.35, pRing);
    shadow.scale.set(lerp(1.6, R * 2.6, pRing), lerp(0.6, R * 2.6, pRing), 1);
    shadow.material.opacity = lerp(1, 0.6, pRing) * pIn;
    renderer.render(scene, camera);

    for (const el of copies) {
      const a = +el.dataset.from, b = +el.dataset.to, f = 0.05;
      const op = a === 0 ? 1 - seg(p, b - f * 0.4, b + f) : Math.min(seg(p, a - f, a + f * 0.4), 1 - seg(p, b - f * 0.4, b + f));
      el.style.opacity = op.toFixed(3);
      const dy = ((1 - op) * (p < a ? 28 : -28)).toFixed(1);
      el.style.transform = (!mobile && !el.classList.contains('csl-hero__copy--center')) ? `translate3d(0, calc(-50% + ${dy}px), 0)` : `translate3d(0, ${dy}px, 0)`;
      el.style.visibility = op < 0.01 ? 'hidden' : 'visible';
      el.style.pointerEvents = op < 0.5 ? 'none' : '';
    }
    if (bar) bar.style.transform = `scaleX(${p.toFixed(4)})`;
    if (hint) hint.style.opacity = (0.8 * (1 - seg(p, 0.02, 0.08))).toFixed(3);
    if (visible) loop();
  }
  function loop() { if (!raf) raf = requestAnimationFrame(frame); }
  resize(); readScroll(); prog = target;
  root.setAttribute('data-ready', 'true');
  loop();
}
